module.exports = __webpack_public_path__ + "static/disappointed-102807ca467af915d7dfdff0a5f12452.jpg";